

export default function(element){
    window.localStorage.setItem('selectedEmployee', 0);

    const leftNav = element.querySelector('#employeeCarousel .nav--left');
    const rightNav = element.querySelector('#employeeCarousel .nav--right');
    const galleryThumbs = element.querySelectorAll('.gallery__card');

    let currentIndex = getFiveStarEmployee();
    let currentSelected = galleryThumbs[currentIndex];
    currentSelected.classList.add("gallery__card--active");

    leftNav.addEventListener('click', ()=>{
        currentIndex <= 0 ? currentIndex = galleryThumbs.length - 1 : currentIndex-- ;
        window.localStorage.setItem('selectedEmployee', currentIndex);
        changeCarousel(currentIndex);
    });

    rightNav.addEventListener('click', ()=>{
        currentIndex >= galleryThumbs.length - 1 ? currentIndex = 0 : currentIndex++;
        window.localStorage.setItem('selectedEmployee', currentIndex);
        changeCarousel(currentIndex);
    });

    function changeCarousel(index){
        currentSelected.classList.remove("gallery__card--active");
        currentSelected = galleryThumbs[currentIndex];
        currentSelected.classList.add("gallery__card--active");
    }

    function getFiveStarEmployee() {
        const employeeIds = JSON.parse(element.dataset.employeeIds);
        const fiveStarEmployeeId = ( getCookieValue('FiveStarSelectedEmployee') );

        if (fiveStarEmployeeId) {
            const index = employeeIds.indexOf(parseInt(fiveStarEmployeeId));
            return index > -1 ? index : 0;
        } else {
            return 0;
        }
    }
}

function getCookieValue(a) {
    var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
}